import React from 'react';
import { useNavigate } from 'react-router-dom';
import RemoveShoppingCartOutlinedIcon from '@mui/icons-material/RemoveShoppingCartOutlined';
import PaymentResultPanel from './PaymentResultPanel';

/**
 * Where Stripe Checkout returns when the customer backs out. Nothing was
 * charged and the plan is unchanged, so this is neutral, not an error.
 * "Choose a plan" reopens the plan picker on Plan and billing.
 */
const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PaymentResultPanel
      tone="neutral"
      icon={<RemoveShoppingCartOutlinedIcon />}
      title="Checkout cancelled"
      description="You weren't charged, and your plan hasn't changed."
      primaryAction={{ label: 'Choose a plan', onClick: () => navigate('/billing', { state: { openPlanPicker: true } }) }}
      secondaryAction={{ label: 'Back to plan and billing', onClick: () => navigate('/billing') }}
    />
  );
};

export default PaymentCancel;
